// import React, { useState, useRef, useEffect } from 'react';
// import { apiCall } from '@/api/apiCall';
// import { toast } from 'sonner';
// import { useApiQueue } from '@/hooks/useApiQueue';
// import TaifContract from '@/assets/img/TaifContract.png';
// import { AssetsPanel } from '../../components/shared/AssetsPanel';
// import LoadingComponent from '@/components/common/LoadingComponent';
// import { API_CALL_TIME } from '@/constants/constant';

// // ─── Fallback Data ────────────────────────────────────────────────────────────
// const FALLBACK_PROFILE = {
//   table_key: 'gazzaz_real_estate_profile',
//   title: 'Gazzaz Real Estate - Profile',
//   data: {
//     project_name:    { label: 'Project Name', value: 'Gazzaz' },
//     contract_term:   { label: 'Contract Term', value: '25 years' },
//     contract_period: { start_date: '29/03/2017', end_date: '29/06/2041' },
//   },
// };

// const FALLBACK_FLOORS = {
//   table_key: 'gazzaz_building_floors_breakdown',
//   title: 'Gazzaz Building Floor Breakdown',
//   data: {
//     columns: [
//       { column_key: 'building_floor', label: 'BUILDING FLOOR', type: 'text' },
//       { column_key: 'floor_details', label: '06', type: 'group', sub_columns: [
//         { column_key: 'floor_number', label: '', type: 'text' },
//         { column_key: 'floor_type',   label: '', type: 'text' },
//       ]},
//       { column_key: 'qty', label: 'QTY', type: 'text' },
//     ],
//     rows: [
//       { building_floor: '', floor_number: '1st FLOOR', floor_type: 'SHOPS',            qty: '41', building_rowSpan: 6 },
//       { building_floor: '', floor_number: '2nd FLOOR', floor_type: 'Al Abeer Clinics', qty: 'Complete Floor' },
//       { building_floor: '', floor_number: '3rd FLOOR', floor_type: 'PARKING',          qty: '287 Parking Bays', rowSpan: 4 },
//       { building_floor: '', floor_number: '4th FLOOR', floor_type: 'PARKING',          hideQty: true },
//       { building_floor: '', floor_number: '5th FLOOR', floor_type: 'PARKING',          hideQty: true },
//       { building_floor: '', floor_number: '6th FLOOR', floor_type: 'PARKING',          hideQty: true },
//     ],
//   },
// };

// const FALLBACK_ASSETS = {
//   table_key: 'gazzaz_assets_deployed',
//   title: 'Gazzaz Off-Street',
//   data: {
//     groups: [
//       { group_name: 'Ticket Dispenser',    group_total_qty: '1', items: [{ item_name: 'DIP G100', qty: '-' }, { item_name: 'G100 64 Bit', qty: '1' }, { item_name: 'G100 32 Bit', qty: '-' }] },
//       { group_name: 'Ticket Verifier',     group_total_qty: '-', items: [{ item_name: 'EV DIP G100', qty: '-' }, { item_name: 'EV G100 64 Bit', qty: '-' }, { item_name: 'EV G100 32 Bit', qty: '-' }] },
//       { group_name: "APM's",               group_total_qty: '1', items: [{ item_name: 'APM ETS-70', qty: '1' }, { item_name: 'APM ETS-100', qty: '-' }] },
//       { group_name: 'PIN Pad',             group_total_qty: '1', items: [{ item_name: 'IUP250', qty: '1' }] },
//       { group_name: 'Card Reader',         group_total_qty: '1', items: [{ item_name: 'IUR250', qty: '1' }] },
//       { group_name: 'B-Contactless',       group_total_qty: '1', items: [{ item_name: 'IUC150', qty: '1' }] },
//       { group_name: 'RFID Reader',         group_total_qty: '2', items: [] },
//       { group_name: 'IP Barrier',          group_total_qty: '2', items: [] },
//       { group_name: 'ANPR Camera',         group_total_qty: '2', items: [{ item_name: 'ARH', qty: '2' }, { item_name: 'Lumenera', qty: '-' }] },
//       { group_name: 'Sliding Gate',        group_total_qty: '-', items: [{ item_name: 'RIGHT', qty: '-' }, { item_name: 'LEFT', qty: '-' }] },
//       { group_name: "PND's",               group_total_qty: '-', items: [{ item_name: 'TPAL BNA-Large', qty: '-' }, { item_name: 'T-PAL TX', qty: '-' }, { item_name: 'T-PAL V2', qty: '-' }] },
//       { group_name: 'Pound Cashier Device',group_total_qty: '-', items: [{ item_name: 'CN-50', qty: '-' }] },
//       { group_name: 'Driver Device',       group_total_qty: '2', items: [{ item_name: 'CN-51', qty: '2' }] },
//       { group_name: 'Enf Device',          group_total_qty: '-', items: [{ item_name: 'Oukitel WP2', qty: '-' }, { item_name: 'Doogee V10', qty: '-' }] },
//       { group_name: 'Validation',          group_total_qty: '-', items: [{ item_name: 'Lenova Tablet', qty: '-' }] },
//       { group_name: 'Printer',             group_total_qty: '2', items: [{ item_name: 'PR-3', qty: '2' }, { item_name: 'SEWOO', qty: '-' }, { item_name: 'BIXOLON', qty: '-' }] },
//       { group_name: 'Tow Truck',           group_total_qty: '-', items: [] },
//       { group_name: 'Clamp Vehicle',       group_total_qty: '-', items: [] },
//       { group_name: 'Support Vehicle',     group_total_qty: '-', items: [] },
//     ],
//   },
// };

// // ─── Helpers ──────────────────────────────────────────────────────────────────
// const groupsToFlat = (groups = []) => {
//   const result = [];
//   groups.forEach(g => {
//     result.push({ name: g.group_name || '', isCategory: true, subCount: '', totalCount: String(g.group_total_qty ?? '-') });
//     (g.items || []).forEach(item => {
//       result.push({ name: item.item_name || '', isCategory: false, subCount: String(item.qty ?? '-'), totalCount: '' });
//     });
//   });
//   return result;
// };

// const flatToGroups = (flat) => {
//   const groups = [];
//   let cur = null;
//   flat.forEach(a => {
//     if (a.isCategory) {
//       if (cur) groups.push(cur);
//       cur = { group_name: a.name, group_total_qty: a.totalCount || '', items: [] };
//     } else if (cur) {
//       cur.items.push({ item_name: a.name, qty: a.subCount || '' });
//     }
//   });
//   if (cur) groups.push(cur);
//   return groups;
// };

// // ─────────────────────────────────────────────────────────────────────────────
// const Gazzaz_4 = ({ year = '', monthNumber = '', contract = '' }) => {
//   const saveTimeoutRef = useRef(null);
//   const [isSaving, setIsSaving] = useState(false);
//   const [profileData, setProfileData] = useState(null);
//   const [floorsData, setFloorsData] = useState(null);
//   const [assetsData, setAssetsData] = useState(null);
  
//   const { enqueue } = useApiQueue();
  
//   // Refs for profile inputs
//   const projectNameRef = useRef(null);
//   const contractTermRef = useRef(null);
//   const contractStartDateRef = useRef(null);
//   const contractEndDateRef = useRef(null);
  
//   // Refs for floors table
//   const floorsCountLabelRef = useRef(null);
//   const buildingFloorRefs = useRef([]);
//   const floorNumberRefs = useRef([]);
//   const floorTypeRefs = useRef([]);
//   const floorQtyRefs = useRef([]);
  
//   // Refs for assets
//   const assetSubCountRefs = useRef([]);
//   const assetTotalCountRefs = useRef([]);

//   // State refs for data
//   const profileDataRef = useRef(null);
//   const floorsDataRef = useRef(null);
//   const assetsDataRef = useRef(null);

//   // ── Fetch ─────────────────────────────────────────────────────────────────
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await enqueue(() =>
//           apiCall('GET', '/boardpack/get-tables-data', { year, contract, month: monthNumber }));
//         if (!response?.success) return;
//         const data = response?.data || [];
//         const find = (key, fb) => data.find(t => t.table_key === key) || fb;
        
//         const profile = find('gazzaz_real_estate_profile', FALLBACK_PROFILE);
//         const floors = find('gazzaz_building_floors_breakdown', FALLBACK_FLOORS);
//         const assets = find('gazzaz_assets_deployed', FALLBACK_ASSETS);
        
//         setProfileData(profile);
//         setFloorsData(floors);
//         setAssetsData(assets);
        
//         profileDataRef.current = profile;
//         floorsDataRef.current = floors;
//         assetsDataRef.current = assets;
//       } catch (err) {
//         console.error('Fetch error:', err);
//       }
//     };
//     fetchData();
//   }, [year, monthNumber, contract]);

//   // ── Auto-save ─────────────────────────────────────────────────────────────
//   const autoSave = () => {
//     if (saveTimeoutRef.current) clearTimeout(saveTimeoutRef.current);
//     saveTimeoutRef.current = setTimeout(saveToAPI, API_CALL_TIME);
//   };

//   const transformAssetsToApiFormat = () => {
//     const currentAssets = assetsDataRef.current?.data?.groups || [];
//     const groups = [];
//     let currentGroup = null;
//     let flatIdx = 0;

//     currentAssets.forEach((group) => {
//       currentGroup = {
//         group_name: group.group_name,
//         group_total_qty: assetTotalCountRefs.current[flatIdx]?.value || group.group_total_qty || '-',
//         items: []
//       };
//       flatIdx++;
      
//       (group.items || []).forEach((item) => {
//         currentGroup.items.push({
//           item_name: item.item_name,
//           qty: assetSubCountRefs.current[flatIdx]?.value || item.qty || '-'
//         });
//         flatIdx++;
//       });
      
//       groups.push(currentGroup);
//     });
    
//     return groups;
//   };

//   const saveToAPI = async () => {
//     try {
//       setIsSaving(true);
      
//       // Get current values from refs
//       const currentProjectName = projectNameRef.current?.value || profileDataRef.current?.data?.project_name?.value || '';
//       const currentContractTerm = contractTermRef.current?.value || profileDataRef.current?.data?.contract_term?.value || '';
//       const currentStartDate = contractStartDateRef.current?.value || profileDataRef.current?.data?.contract_period?.start_date || '';
//       const currentEndDate = contractEndDateRef.current?.value || profileDataRef.current?.data?.contract_period?.end_date || '';
//       const currentFloorsCountLabel = floorsCountLabelRef.current?.value || floorsDataRef.current?.data?.columns?.find(c => c.type === 'group')?.label || '';
      
//       // Build floors rows from refs
//       const currentFloorRows = (floorsDataRef.current?.data?.rows || []).map((row, idx) => ({
//         building_floor: buildingFloorRefs.current[idx]?.value || row.building_floor || '',
//         floor_number: floorNumberRefs.current[idx]?.value || row.floor_number || '',
//         floor_type: floorTypeRefs.current[idx]?.value || row.floor_type || '',
//         qty: floorQtyRefs.current[idx]?.value || row.qty || '',
//         building_rowSpan: row.building_rowSpan,
//         rowSpan: row.rowSpan,
//         hideQty: row.hideQty
//       }));
      
//       const response = await apiCall('POST', '/boardpack/add-tables-data', {
//         contract, year, month: monthNumber, created_by: 1,
//         tables: [
//           { 
//             table_key: profileDataRef.current?.table_key || 'gazzaz_real_estate_profile', 
//             title: profileDataRef.current?.title || 'Gazzaz Real Estate - Profile', 
//             data: {
//               project_name: { label: 'Project Name', value: currentProjectName },
//               contract_term: { label: 'Contract Term', value: currentContractTerm },
//               contract_period: { start_date: currentStartDate, end_date: currentEndDate }
//             }
//           },
//           { 
//             table_key: floorsDataRef.current?.table_key || 'gazzaz_building_floors_breakdown', 
//             title: floorsDataRef.current?.title || 'Gazzaz Building Floor Breakdown', 
//             data: {
//               columns: floorsDataRef.current?.data?.columns?.map(col => 
//                 col.type === 'group' ? { ...col, label: currentFloorsCountLabel } : col
//               ),
//               rows: currentFloorRows
//             }
//           },
//           { 
//             table_key: assetsDataRef.current?.table_key || 'gazzaz_assets_deployed', 
//             title: assetsDataRef.current?.title || 'Gazzaz Off-Street', 
//             data: { groups: transformAssetsToApiFormat() }
//           },
//         ],
//       });
      
//       if (!response?.success) throw new Error(response?.message);
//       // toast.success('Data saved successfully');
//     } catch (err) {
//       console.error('Save error:', err);
//       toast.error('Failed to save changes');
//     } finally {
//       setIsSaving(false);
//     }
//   };

//   if (!profileData || !floorsData || !assetsData) {
//     return <LoadingComponent/>;
//   }

//   const pd = profileData.data;
//   const fd = floorsData.data;
//   const floorsCountLabel = fd.columns?.find(c => c.type === 'group')?.label || '';
//   const floorRows = fd.rows || [];
//   const flatAssets = groupsToFlat(assetsData.data.groups);

//   return (
//     <div className="min-h-screen p-4 md:p-6 lg:p-8 bg-white">
//       {/* ── Header ── */}
//       <div className="flex justify-between items-center mb-3">
//         <div className="ml-2">
//           <img src={TaifContract} alt="Bab Al Ree Logo" style={{ height: '50px', objectFit: 'contain' }} />
//         </div>
//         <h1 className="text-xl font-bold flex-1 text-center">{profileData.title}</h1>
//       </div>

//       <div className="flex flex-col lg:flex-row gap-0 !border-2 !border-black p-3">

//         {/* ── Left ── */}
//         <div className="flex-1 !border-black pr-4">
//           <div className="text-[13px] font-semibold mb-4">Activities:</div>

//           {/* Project Name */}
//           <div className="flex items-center gap-2 mb-1 ml-4">
//             <div className="w-4 h-4 !border-2 !border-blue-600 flex-shrink-0" />
//             <span className="text-[12px]">
//               {pd.project_name?.label}{' '}
//               <strong>
//                 <input 
//                   type="text" 
//                   defaultValue={pd.project_name?.value || ''}
//                   ref={projectNameRef}
//                   onChange={autoSave}
//                   className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px]" 
//                 />
//               </strong>
//             </span>
//           </div>

//           {/* Contract Term */}
//           <div className="flex items-center gap-2 mb-1 ml-10">
//             <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//             <span className="text-[12px] flex items-center flex-wrap gap-1">
//               Contract term{' '}
//               <strong>
//                 <input 
//                   type="text" 
//                   defaultValue={pd.contract_term?.value || ''}
//                   ref={contractTermRef}
//                   onChange={autoSave}
//                   className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-13" 
//                 />
//               </strong>
//               ; start date{' '}
//               <strong>
//                 <input 
//                   type="text" 
//                   defaultValue={pd.contract_period?.start_date || ''}
//                   ref={contractStartDateRef}
//                   onChange={autoSave}
//                   className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-18" 
//                 />
//               </strong>
//               {' to '}
//               <strong>
//                 <input 
//                   type="text" 
//                   defaultValue={pd.contract_period?.end_date || ''}
//                   ref={contractEndDateRef}
//                   onChange={autoSave}
//                   className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-24" 
//                 />
//               </strong>
//             </span>
//           </div>

//           {/* Assets Deployed */}
//           <div className="flex items-center gap-2 ml-10 mb-6">
//             <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
//             <span className="text-[12px]">Assets Deployed for Car Parking</span>
//           </div>

//           {/* Building Floors Table */}
//           <div className="ml-10">
//             <table className="!border-collapse text-[11px]">
//               <thead>
//                 <tr>
//                   <th rowSpan={2} className="!border !border-black px-3 py-1 font-bold text-center align-middle bg-white" style={{ minWidth: '120px' }}>
//                     BUILDING FLOOR
//                   </th>
//                   <th colSpan={2} className="!border !border-black px-3 py-1 font-bold text-center bg-white" style={{ minWidth: '160px' }}>
//                     <input 
//                       type="text" 
//                       defaultValue={floorsCountLabel} 
//                       ref={floorsCountLabelRef}
//                       onChange={autoSave}
//                       className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-center w-16 text-[11px]" 
//                     />
//                   </th>
//                   <th rowSpan={2} className="!border !border-black px-3 py-1 font-bold text-center align-middle bg-white" style={{ minWidth: '150px' }}>
//                     QTY
//                   </th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {floorRows.map((row, idx) => (
//                   <tr key={idx}>
//                     {idx === 0 ? (
//                       <td rowSpan={row.building_rowSpan || floorRows.length} className="!border !border-black px-2 py-1 text-center align-middle">
//                         <input
//                           type="text"
//                           defaultValue={row.building_floor || ''}
//                           ref={(el) => (buildingFloorRefs.current[idx] = el)}
//                           onChange={autoSave}
//                           className="outline-none bg-transparent !border-0 w-full text-center text-[11px]"
//                         />
//                       </td>
//                     ) : null}
//                     <td className="!border !border-black px-2 py-1">
//                       <input 
//                         type="text" 
//                         defaultValue={row.floor_number || ''} 
//                         ref={(el) => (floorNumberRefs.current[idx] = el)}
//                         onChange={autoSave}
//                         className="outline-none bg-transparent !border-0 w-full text-[11px]" 
//                       />
//                     </td>
//                     <td className="!border !border-black px-2 py-1 text-center">
//                       <input 
//                         type="text" 
//                         defaultValue={row.floor_type || ''} 
//                         ref={(el) => (floorTypeRefs.current[idx] = el)}
//                         onChange={autoSave}
//                         className="outline-none bg-transparent !border-0 w-full text-center text-[11px]" 
//                       />
//                     </td>
//                     {!row.hideQty ? (
//                       <td rowSpan={row.rowSpan || 1} className="!border !border-black px-2 py-1 text-center align-middle">
//                         <input
//                           type="text"
//                           defaultValue={row.qty || ''}
//                           ref={(el) => (floorQtyRefs.current[idx] = el)}
//                           onChange={autoSave}
//                           className="outline-none bg-transparent !border-0 w-full text-center text-[11px]"
//                         />
//                       </td>
//                     ) : null}
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>

//         {/* ── Right — Assets ── */}
//         <AssetsPanel
//           assetsTable={assetsData}
//           flatAssets={flatAssets}
//           subCountRefs={assetSubCountRefs}
//           totalCountRefs={assetTotalCountRefs}
//           onSubCount={(index, value) => {
//             const updatedFlat = [...flatAssets];
//             updatedFlat[index] = { ...updatedFlat[index], subCount: value };
//             setAssetsData(prev => ({
//               ...prev,
//               data: { ...prev.data, groups: flatToGroups(updatedFlat) }
//             }));
//             assetsDataRef.current = {
//               ...assetsDataRef.current,
//               data: { ...assetsDataRef.current.data, groups: flatToGroups(updatedFlat) }
//             };
//             autoSave();
//           }}
//           onTotalCount={(index, value) => {
//             const updatedFlat = [...flatAssets];
//             updatedFlat[index] = { ...updatedFlat[index], totalCount: value };
//             setAssetsData(prev => ({
//               ...prev,
//               data: { ...prev.data, groups: flatToGroups(updatedFlat) }
//             }));
//             assetsDataRef.current = {
//               ...assetsDataRef.current,
//               data: { ...assetsDataRef.current.data, groups: flatToGroups(updatedFlat) }
//             };
//             autoSave();
//           }}
//         />
//       </div>

//       {/* {isSaving && (
//         <div className="fixed bottom-4 right-4 bg-blue-600 text-white text-xs px-3 py-1.5 rounded shadow-lg z-50">
//           Saving...
//         </div>
//       )} */}
//     </div>
//   );
// };

// export default Gazzaz_4;











import React, { useState, useRef, useEffect } from 'react';
import { apiCall } from '@/api/apiCall';
import { toast } from 'sonner';
import { useApiQueue } from '@/hooks/useApiQueue';
import TaifContract from '@/assets/img/TaifContract.png';
import { AssetsPanel } from '../../components/shared/AssetsPanel';
import LoadingComponent from '@/components/common/LoadingComponent';
import { API_CALL_TIME } from '@/constants/constant';

// ─── Fallback Data ────────────────────────────────────────────────────────────
const FALLBACK_PROFILE = {
  table_key: 'gazzaz_real_estate_profile',
  title: 'Gazzaz Real Estate - Profile',
  data: {
    project_name:    { label: 'Project Name', value: 'Gazzaz' },
    contract_term:   { label: 'Contract Term', value: '25 years' },
    contract_period: { start_date: '29/03/2017', end_date: '29/06/2041' },
  },
};

const FALLBACK_FLOORS = {
  table_key: 'gazzaz_building_floors_breakdown',
  title: 'Gazzaz Building Floor Breakdown',
  data: {
    columns: [
      { column_key: 'building_floor', label: 'BUILDING FLOOR', type: 'text' },
      { column_key: 'floor_details', label: '06', type: 'group', sub_columns: [
        { column_key: 'floor_number', label: '', type: 'text' },
        { column_key: 'floor_type',   label: '', type: 'text' },
      ]},
      { column_key: 'qty', label: 'QTY', type: 'text' },
    ],
    rows: [
      { building_floor: '', floor_number: '1st FLOOR', floor_type: 'SHOPS',            qty: '41', building_rowSpan: 6 },
      { building_floor: '', floor_number: '2nd FLOOR', floor_type: 'Al Abeer Clinics', qty: 'Complete Floor' },
      { building_floor: '', floor_number: '3rd FLOOR', floor_type: 'PARKING',          qty: '287 Parking Bays', rowSpan: 4 },
      { building_floor: '', floor_number: '4th FLOOR', floor_type: 'PARKING',          hideQty: true },
      { building_floor: '', floor_number: '5th FLOOR', floor_type: 'PARKING',          hideQty: true },
      { building_floor: '', floor_number: '6th FLOOR', floor_type: 'PARKING',          hideQty: true },
    ],
  },
};

const FALLBACK_ASSETS = {
  table_key: 'gazzaz_assets_deployed',
  title: 'Gazzaz Off-Street',
  data: {
    groups: [
      { group_name: 'Ticket Dispenser',    group_total_qty: '1', items: [{ item_name: 'DIP G100', qty: '-' }, { item_name: 'G100 64 Bit', qty: '1' }, { item_name: 'G100 32 Bit', qty: '-' }] },
      { group_name: 'Ticket Verifier',     group_total_qty: '-', items: [{ item_name: 'EV DIP G100', qty: '-' }, { item_name: 'EV G100 64 Bit', qty: '-' }, { item_name: 'EV G100 32 Bit', qty: '-' }] },
      { group_name: "APM's",               group_total_qty: '1', items: [{ item_name: 'APM ETS-70', qty: '1' }, { item_name: 'APM ETS-100', qty: '-' }] },
      { group_name: 'PIN Pad',             group_total_qty: '1', items: [{ item_name: 'IUP250', qty: '1' }] },
      { group_name: 'Card Reader',         group_total_qty: '1', items: [{ item_name: 'IUR250', qty: '1' }] },
      { group_name: 'B-Contactless',       group_total_qty: '1', items: [{ item_name: 'IUC150', qty: '1' }] },
      { group_name: 'RFID Reader',         group_total_qty: '2', items: [] },
      { group_name: 'IP Barrier',          group_total_qty: '2', items: [] },
      { group_name: 'ANPR Camera',         group_total_qty: '2', items: [{ item_name: 'ARH', qty: '2' }, { item_name: 'Lumenera', qty: '-' }] },
      { group_name: 'Sliding Gate',        group_total_qty: '-', items: [{ item_name: 'RIGHT', qty: '-' }, { item_name: 'LEFT', qty: '-' }] },
      { group_name: "PND's",               group_total_qty: '-', items: [{ item_name: 'TPAL BNA-Large', qty: '-' }, { item_name: 'T-PAL TX', qty: '-' }, { item_name: 'T-PAL V2', qty: '-' }] },
      { group_name: 'Pound Cashier Device',group_total_qty: '-', items: [{ item_name: 'CN-50', qty: '-' }] },
      { group_name: 'Driver Device',       group_total_qty: '2', items: [{ item_name: 'CN-51', qty: '2' }] },
      { group_name: 'Enf Device',          group_total_qty: '-', items: [{ item_name: 'Oukitel WP2', qty: '-' }, { item_name: 'Doogee V10', qty: '-' }] },
      { group_name: 'Validation',          group_total_qty: '-', items: [{ item_name: 'Lenova Tablet', qty: '-' }] },
      { group_name: 'Printer',             group_total_qty: '2', items: [{ item_name: 'PR-3', qty: '2' }, { item_name: 'SEWOO', qty: '-' }, { item_name: 'BIXOLON', qty: '-' }] },
      { group_name: 'Tow Truck',           group_total_qty: '-', items: [] },
      { group_name: 'Clamp Vehicle',       group_total_qty: '-', items: [] },
      { group_name: 'Support Vehicle',     group_total_qty: '-', items: [] },
    ],
  },
};

// ─── Helpers ──────────────────────────────────────────────────────────────────
const groupsToFlat = (groups = []) => {
  const result = [];
  groups.forEach(g => {
    result.push({ name: g.group_name || '', isCategory: true, subCount: '', totalCount: String(g.group_total_qty ?? '-') });
    (g.items || []).forEach(item => {
      result.push({ name: item.item_name || '', isCategory: false, subCount: String(item.qty ?? '-'), totalCount: '' });
    });
  });
  return result;
};

const flatToGroups = (flat) => {
  const groups = [];
  let cur = null;
  flat.forEach(a => {
    if (a.isCategory) {
      if (cur) groups.push(cur);
      cur = { group_name: a.name, group_total_qty: a.totalCount || '', items: [] };
    } else if (cur) {
      cur.items.push({ item_name: a.name, qty: a.subCount || '' });
    }
  });
  if (cur) groups.push(cur);
  return groups;
};

// ─────────────────────────────────────────────────────────────────────────────
const Gazzaz_4 = ({ year = '', month = '', monthNumber = '', contract = '' }) => {
  const saveTimeoutRef = useRef(null);
  const [isSaving, setIsSaving] = useState(false);
  const hasFetchedRef = useRef(false);
  
  // 🔥 State for second API (parking bays)
  const [parkingBaysData, setParkingBaysData] = useState(null);
  
  const [profileData, setProfileData] = useState(null);
  const [floorsData, setFloorsData] = useState(null);
  const [assetsData, setAssetsData] = useState(null);
  
  const { enqueue } = useApiQueue();
  
  // 🔥 Effective total parking bays - second API se aayega
  const effectiveTotalBays = parkingBaysData?.total_bays ?? 287;
  
  // Refs for profile inputs
  const projectNameRef = useRef(null);
  const contractTermRef = useRef(null);
  const contractStartDateRef = useRef(null);
  const contractEndDateRef = useRef(null);
  
  // Refs for floors table
  const floorsCountLabelRef = useRef(null);
  const buildingFloorRefs = useRef([]);
  const floorNumberRefs = useRef([]);
  const floorTypeRefs = useRef([]);
  const floorQtyRefs = useRef([]);
  
  // Refs for assets
  const assetSubCountRefs = useRef([]);
  const assetTotalCountRefs = useRef([]);

  // State refs for data
  const profileDataRef = useRef(null);
  const floorsDataRef = useRef(null);
  const assetsDataRef = useRef(null);

  // ── Fetch BOTH APIs ─────────────────────────────────────────────────────────────────
  useEffect(() => {
    if (hasFetchedRef.current) return;
    hasFetchedRef.current = true;
    fetchAllData();
  }, [year, month, monthNumber, contract]);

  const fetchAllData = async () => {
    try {
      // 🔥 Second API params - 'type' not 'value'
      const secondApiParams = {
        contract: "0020011",
        year: year,
        month: month,     // using 'month' (string like "Oct")
        type: "off_street"
      };
      
      const [firstApiResponse, secondApiResponse] = await Promise.all([
        enqueue(() => apiCall('GET', '/boardpack/get-tables-data', { year, contract, month: monthNumber })),
        enqueue(() => apiCall('GET', '/boardpack/parking/bays', secondApiParams))
      ]);

      // Process first API response
      if (firstApiResponse?.success) {
        const data = firstApiResponse?.data || [];
        const find = (key, fb) => data.find(t => t.table_key === key) || fb;
        
        const profile = find('gazzaz_real_estate_profile', FALLBACK_PROFILE);
        const floors = find('gazzaz_building_floors_breakdown', FALLBACK_FLOORS);
        const assets = find('gazzaz_assets_deployed', FALLBACK_ASSETS);
        
        setProfileData(profile);
        setFloorsData(floors);
        setAssetsData(assets);
        
        profileDataRef.current = profile;
        floorsDataRef.current = floors;
        assetsDataRef.current = assets;
      }

      // 🔥 Process second API response for parking bays
      if (secondApiResponse?.success && secondApiResponse?.data) {
        setParkingBaysData(secondApiResponse.data);
      } else {
        console.warn("Second API failed:", secondApiResponse?.message);
        setParkingBaysData(null);
      }
      
    } catch (err) {
      console.error('Fetch error:', err);
    }
  };

  // ── Auto-save ─────────────────────────────────────────────────────────────
  const autoSave = () => {
    if (saveTimeoutRef.current) clearTimeout(saveTimeoutRef.current);
    saveTimeoutRef.current = setTimeout(saveToAPI, API_CALL_TIME);
  };

  const transformAssetsToApiFormat = () => {
    const currentAssets = assetsDataRef.current?.data?.groups || [];
    const groups = [];
    let currentGroup = null;
    let flatIdx = 0;

    currentAssets.forEach((group) => {
      currentGroup = {
        group_name: group.group_name,
        group_total_qty: assetTotalCountRefs.current[flatIdx]?.value || group.group_total_qty || '-',
        items: []
      };
      flatIdx++;
      
      (group.items || []).forEach((item) => {
        currentGroup.items.push({
          item_name: item.item_name,
          qty: assetSubCountRefs.current[flatIdx]?.value || item.qty || '-'
        });
        flatIdx++;
      });
      
      groups.push(currentGroup);
    });
    
    return groups;
  };

  const saveToAPI = async () => {
    try {
      setIsSaving(true);
      
      // Get current values from refs
      const currentProjectName = projectNameRef.current?.value || profileDataRef.current?.data?.project_name?.value || '';
      const currentContractTerm = contractTermRef.current?.value || profileDataRef.current?.data?.contract_term?.value || '';
      const currentStartDate = contractStartDateRef.current?.value || profileDataRef.current?.data?.contract_period?.start_date || '';
      const currentEndDate = contractEndDateRef.current?.value || profileDataRef.current?.data?.contract_period?.end_date || '';
      const currentFloorsCountLabel = floorsCountLabelRef.current?.value || floorsDataRef.current?.data?.columns?.find(c => c.type === 'group')?.label || '';
      
      // Build floors rows from refs
      const currentFloorRows = (floorsDataRef.current?.data?.rows || []).map((row, idx) => ({
        building_floor: buildingFloorRefs.current[idx]?.value || row.building_floor || '',
        floor_number: floorNumberRefs.current[idx]?.value || row.floor_number || '',
        floor_type: floorTypeRefs.current[idx]?.value || row.floor_type || '',
        qty: floorQtyRefs.current[idx]?.value || row.qty || '',
        building_rowSpan: row.building_rowSpan,
        rowSpan: row.rowSpan,
        hideQty: row.hideQty
      }));
      
      const response = await apiCall('POST', '/boardpack/add-tables-data', {
        contract, year, month: monthNumber, created_by: 1,
        tables: [
          { 
            table_key: profileDataRef.current?.table_key || 'gazzaz_real_estate_profile', 
            title: profileDataRef.current?.title || 'Gazzaz Real Estate - Profile', 
            data: {
              project_name: { label: 'Project Name', value: currentProjectName },
              contract_term: { label: 'Contract Term', value: currentContractTerm },
              contract_period: { start_date: currentStartDate, end_date: currentEndDate }
            }
          },
          { 
            table_key: floorsDataRef.current?.table_key || 'gazzaz_building_floors_breakdown', 
            title: floorsDataRef.current?.title || 'Gazzaz Building Floor Breakdown', 
            data: {
              columns: floorsDataRef.current?.data?.columns?.map(col => 
                col.type === 'group' ? { ...col, label: currentFloorsCountLabel } : col
              ),
              rows: currentFloorRows
            }
          },
          { 
            table_key: assetsDataRef.current?.table_key || 'gazzaz_assets_deployed', 
            title: assetsDataRef.current?.title || 'Gazzaz Off-Street', 
            data: { groups: transformAssetsToApiFormat() }
          },
        ],
      });
      
      if (!response?.success) throw new Error(response?.message);
    } catch (err) {
      console.error('Save error:', err);
      toast.error('Failed to save changes');
    } finally {
      setIsSaving(false);
    }
  };

  if (!profileData || !floorsData || !assetsData) {
    return <LoadingComponent/>;
  }

  const pd = profileData.data;
  const fd = floorsData.data;
  const floorsCountLabel = fd.columns?.find(c => c.type === 'group')?.label || '';
  const floorRows = fd.rows || [];
  const flatAssets = groupsToFlat(assetsData.data.groups);

  return (
    <div className="min-h-screen p-8 bg-white">
      {/* ── Header ── */}
      <div className="flex justify-between items-center mb-3">
        <div className="ml-2">
          <img src={TaifContract} alt="Bab Al Ree Logo" style={{ height: '50px', objectFit: 'contain' }} />
        </div>
        <h1 className="text-xl font-bold flex-1 text-center">{profileData.title}</h1>
      </div>

      <div className="flex flex-row gap-0 !border-2 !border-black p-3">

        {/* ── Left ── */}
        <div className="flex-1 !border-black pr-4">
          <div className="text-[13px] font-semibold mb-4">Activities:</div>

          {/* Project Name - Editable */}
          <div className="flex items-center gap-2 mb-1 ml-4">
            <div className="w-4 h-4 !border-2 !border-blue-600 flex-shrink-0" />
            <span className="text-[12px]">
              {pd.project_name?.label}{' '}
              <strong>
                <input 
                  type="text" 
                  defaultValue={pd.project_name?.value || ''}
                  ref={projectNameRef}
                  onChange={autoSave}
                  className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px]" 
                />
              </strong>
            </span>
          </div>

          {/* Contract Term - Editable */}
          <div className="flex items-center gap-2 mb-1 ml-10">
            <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
            <span className="text-[12px] flex items-center flex-wrap gap-1">
              Contract term{' '}
              <strong>
                <input 
                  type="text" 
                  defaultValue={pd.contract_term?.value || ''}
                  ref={contractTermRef}
                  onChange={autoSave}
                  className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-13" 
                />
              </strong>
              ; start date{' '}
              <strong>
                <input 
                  type="text" 
                  defaultValue={pd.contract_period?.start_date || ''}
                  ref={contractStartDateRef}
                  onChange={autoSave}
                  className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-18" 
                />
              </strong>
              {' to '}
              <strong>
                <input 
                  type="text" 
                  defaultValue={pd.contract_period?.end_date || ''}
                  ref={contractEndDateRef}
                  onChange={autoSave}
                  className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-24" 
                />
              </strong>
            </span>
          </div>

          {/* Assets Deployed */}
          <div className="flex items-center gap-2 ml-10 mb-6">
            <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
            <span className="text-[12px]">Assets Deployed for Car Parking</span>
          </div>

          {/* Building Floors Table */}
          <div className="ml-10">
            <table className="!border-collapse text-[11px]">
              <thead>
                <tr>
                  <th rowSpan={2} className="!border !border-black px-3 py-1 font-bold text-center align-middle bg-white" style={{ minWidth: '120px' }}>
                    BUILDING FLOOR
                  </th>
                  <th colSpan={2} className="!border !border-black px-3 py-1 font-bold text-center bg-white" style={{ minWidth: '160px' }}>
                    <input 
                      type="text" 
                      defaultValue={floorsCountLabel} 
                      ref={floorsCountLabelRef}
                      onChange={autoSave}
                      className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-center w-16 text-[11px]" 
                    />
                  </th>
                  <th rowSpan={2} className="!border !border-black px-3 py-1 font-bold text-center align-middle bg-white" style={{ minWidth: '150px' }}>
                    QTY
                  </th>
                </tr>
              </thead>
              <tbody>
                {floorRows.map((row, idx) => {
                  const isParkingRow = row.floor_type === 'PARKING' && row.qty?.includes('Parking Bays');
                  
                  return (
                    <tr key={idx}>
                      {idx === 0 ? (
                        <td rowSpan={row.building_rowSpan || floorRows.length} className="!border !border-black px-2 py-1 text-center align-middle">
                          <input
                            type="text"
                            defaultValue={row.building_floor || ''}
                            ref={(el) => (buildingFloorRefs.current[idx] = el)}
                            onChange={autoSave}
                            className="outline-none bg-transparent !border-0 w-full text-center text-[11px]"
                          />
                        </td>
                      ) : null}
                      <td className="!border !border-black px-2 py-1">
                        <input 
                          type="text" 
                          defaultValue={row.floor_number || ''} 
                          ref={(el) => (floorNumberRefs.current[idx] = el)}
                          onChange={autoSave}
                          className="outline-none bg-transparent !border-0 w-full text-[11px]" 
                        />
                      </td>
                      <td className="!border !border-black px-2 py-1 text-center">
                        <input 
                          type="text" 
                          defaultValue={row.floor_type || ''} 
                          ref={(el) => (floorTypeRefs.current[idx] = el)}
                          onChange={autoSave}
                          className="outline-none bg-transparent !border-0 w-full text-center text-[11px]" 
                        />
                      </td>
                      {!row.hideQty ? (
                        <td rowSpan={row.rowSpan || 1} className="!border !border-black px-2 py-1 text-center align-middle">
                          {isParkingRow ? (
                            // 🔥 READ-ONLY - Second API se aaya hai
                            <input
                              type="text"
                              value={`${effectiveTotalBays} Parking Bays`}
                              readOnly
                              disabled
                              className="outline-none bg-transparent !border-0 w-full text-center text-[11px] cursor-default font-medium"
                            />
                          ) : (
                            <input
                              type="text"
                              defaultValue={row.qty || ''}
                              ref={(el) => (floorQtyRefs.current[idx] = el)}
                              onChange={autoSave}
                              className="outline-none bg-transparent !border-0 w-full text-center text-[11px]"
                            />
                          )}
                        </td>
                      ) : null}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>

        {/* ── Right — Assets ── */}
        <AssetsPanel
          assetsTable={assetsData}
          flatAssets={flatAssets}
          subCountRefs={assetSubCountRefs}
          totalCountRefs={assetTotalCountRefs}
          onSubCount={(index, value) => {
            const updatedFlat = [...flatAssets];
            updatedFlat[index] = { ...updatedFlat[index], subCount: value };
            setAssetsData(prev => ({
              ...prev,
              data: { ...prev.data, groups: flatToGroups(updatedFlat) }
            }));
            assetsDataRef.current = {
              ...assetsDataRef.current,
              data: { ...assetsDataRef.current.data, groups: flatToGroups(updatedFlat) }
            };
            autoSave();
          }}
          onTotalCount={(index, value) => {
            const updatedFlat = [...flatAssets];
            updatedFlat[index] = { ...updatedFlat[index], totalCount: value };
            setAssetsData(prev => ({
              ...prev,
              data: { ...prev.data, groups: flatToGroups(updatedFlat) }
            }));
            assetsDataRef.current = {
              ...assetsDataRef.current,
              data: { ...assetsDataRef.current.data, groups: flatToGroups(updatedFlat) }
            };
            autoSave();
          }}
        />
      </div>
    </div>
  );
};

export default Gazzaz_4;